// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Messages-Header-__blasts__container--22HiU","count":"src-components-Messages-Header-__blasts__count--2itGf","patient":"src-components-Messages-Header-__blasts__patient--2OgdP","remove":"src-components-Messages-Header-__blasts__remove--WwTng"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Header/blasts.css
// module id = 1960
// module chunks = 0